import * as React from "react";
import { AuthUtil } from "./utils/auth";
import { Auth } from "./application/domain/auth/auth";
import { emptyFunction } from "./utils/function-utils";

const { useContext, useEffect, useState } = React;

export const useAuthContext = () => {
  const { auth } = useContext(AuthContext);
  return auth;
};

export const useAuthContextV2 = () => useContext(AuthContext);

export const AuthContext = React.createContext<{
  auth: Auth;
  syncAuth: () => void;
}>({
  auth: Auth.noAuth(),
  syncAuth: emptyFunction,
});

export const AuthContextComponent: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [authState, setAuthState] = useState<Auth>(Auth.noAuth());

  const syncAuth = async () => {
    const data = await AuthUtil.checkAuth();
    setAuthState(data);
  };

  useEffect(() => {
    syncAuth();
  }, []);

  return (
    <AuthContext.Provider
      value={{
        auth: authState,
        syncAuth,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
